<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات کاربری برای مشتری '{{CustomerName}}'</h5>


      <form [formGroup]="CustomerUser" (submit)="SubmitCustomerUser()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6" *ngIf="!CurrentUserName">
              <label for="exampleInputEmail1">نام کاربری</label>
              <input formControlName="Username" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_Username().valid && get_Form_Username().touched" class="form-text text-muted MyErrorRedColor">نام کاربری را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6" *ngIf="CurrentUserName">
            <label for="exampleInputEmail1">نام کاربری</label>
            <input disabled value="{{CurrentUserName}}" formControlName="Username" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">رمز عبور</label>
            <input formControlName="Password" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched" class="form-text text-muted MyErrorRedColor">رمز عبور را وارد نمائید. (حداقل 6 کاراکتر)</small>
          </div>
        </div>


        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!CustomerUser.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
        <button routerLink="/Customer" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>
